import { AppContext } from 'types/types';

export const GENERIC_KEY_PLAN_PIN_GROUP_HIDDEN =
  'GENERIC_KEY_PLAN_PIN_GROUP_HIDDEN';
export const GENERIC_OPEN_PLAN_ID = (assetId: string): string =>
  `GENERIC_OPEN_PLAN_ID_${assetId}`;
// export const SIDEBAR_WIDTH = 400
// export const WINDOW_WIDTH_ALLOW_FIXED_SIDEBAR = SIDEBAR_WIDTH * 2.5

export type Pin = {
  id: string;
  name: string;
  x: number;
  y: number;
};

export type PinNew = {
  planId: string;
  x: number;
  y: number;
};

export type PinNewWithName = {
  id: string;
  planId: string;
  name: string;
  group: string;
  x: number;
  y: number;
  color?: string;
};

export type Plan = {
  id: string;
  name: string;
  fileId: string;
  // @added 2022-06-11, API always provides a number from 0 upwards
  filePage?: number;
  pinCount: number;
} & (
  | { fileType?: 'image'; fileWidth?: number; fileHeight?: number }
  | {
      // @added 2023-09-04 - if undefined, default to image
      fileType?: 'pdf' | 'pdfpage' | 'svg' | 'svgpdf' | 'pdfimage';
      // @added 2023-09-04 - for PDFs and SVGs
      fileWidth: number;
      // @added 2023-09-04 - for PDFs and SVGs
      fileHeight: number;
    }
);

export type PlanLoaded = {
  id: string;
  name: string;
  pinCount: number;
  image: {
    type: 'image' | 'pdf' | 'pdfpage' | 'svg' | 'svgpdf' | 'pdfimage';
    page: number;
    width: number;
    height: number;
    base64: string;
    url: string;
    isUsingThumbnail: boolean;
    isFileMissing: boolean;
  };
};

export type PlanState = {
  data:
    | undefined
    | {
        context: AppContext;
        initPin: PinNew | undefined;
        pin: PinNew | undefined;
        pins: PinNewWithName[];
        findNoun?: string | undefined; // e.g. Fire Door
        selectionKey?: string;
        actionAfterFind?: {
          type: string;
          payload: { id: string } & Record<string, unknown>;
        };
        selectedPinId: string | undefined;
        plans: Record<string, Plan>;
        plan: undefined | PlanLoaded;
        plansEditable: boolean;
      };
};
